import { LoadingService } from "./../../core/services/loading.service";
import { Component, OnInit, Output, EventEmitter, Inject, DOCUMENT } from "@angular/core";
import { Router } from "@angular/router";

import { AuthenticationService } from "../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../core/services/authfake.service";
import { environment } from "src/environments/environment";
import { CookieService } from "ngx-cookie-service";
import { LanguageService } from "../../core/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { UserProfileService } from "src/app/core/services/user.service";
import Swal from "sweetalert2";


@Component({
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
    
    styleUrls: ["./topbar.component.scss"],
    standalone: false
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;

  loadings: number = 0;

  dashboard_env: string = environment.environment_name;
  other_envs: { name: string; url: string; active: boolean }[] = environment.external_urls.filter(item => item.name !== this.dashboard_env).map(item => {
    if (item.name === 'tst') {
      return {...item, name: 'Test'};
    } else if (item.name === 'dev') {
      return {...item, name: 'Dev'};
    } else if (item.name === 'prd') {
      return {...item, name: 'Prod'};
    }
    return item;
  });
  userRole: any[];
  isAdminUser: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
    private userService: UserProfileService,
  ) { }

  listLang = [
    { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
    // { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    // { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
    { text: "Italian", flag: "assets/images/flags/italy.jpg", lang: "it" },
    // { text: "Russian", flag: "assets/images/flags/russia.jpg", lang: "ru" },
    { text: "French", flag: "assets/images/flags/french.jpg", lang: "fr" },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get("lang");
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = "assets/images/flags/us.jpg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    let userstring = [];
    let userArray = [];
    this.isAdminUser = this.userService.check_admin_user();
    userArray = this.userService.get_user_role();

    userArray.forEach(element => {
      if (element == 'dealerTechnician') {
        userstring.push('Technician');
      } else if (element == 'dealer') {
        // userstring.push('Dealer');
        userstring.push('EU Admin');
      } else if (element == 'brandSupportOperator') {
        userstring.push('Support');
      } else if (element == 'admin') {
        userstring.push('Admin');
      } else if (element == "brandTechOperator") {
        userstring.push('Staff');
      }
      //  else if (element == 'user') {
      //   userstring.push('User');
      // }
    });

    this.userRole = userstring;
  }
  // changeLang(lang) {
  //   console.log(lang)
  //   localStorage.setItem('lang', lang);
  //   window.location.reload();
  // }

  openLink(link: string, active: boolean) {
    if (active == false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Thi environment is not deployed yet!",
      });
      return;
    }
    window.open(link);
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
    // window.location.reload();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.userService.logout();
    this.router.navigate(["/account/login"]);
  }

  profile(){
    console.log('profile click');
    this.router.navigate(['su_profile']);
  }
  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
